export const FETCH_ARTICLES_STARTED = 'FETCH_ARTICLES_STARTED';
export const FETCH_ARTICLES_FINISHED = 'FETCH_ARTICLES_FINISHED';
export const FETCH_ARTICLES_FAILED = 'FETCH_ARTICLES_FAILED';
export const FETCH_FEATURED_ARTICLES_STARTED =
  'FETCH_FEATURED_ARTICLES_STARTED';
export const FETCH_FEATURED_ARTICLES_FINISHED =
  'FETCH_FEATURED_ARTICLES_FINISHED';
export const FETCH_FEATURED_ARTICLES_FAILED = 'FETCH_FEATURED_ARTICLES_FAILED';
